<template>
  <div>
    <md-card>
      <md-card-content>
        <md-tabs class="md-secondary" md-alignment="centered">
          <!-- Service Start -->
          <md-tab id="tab-services" md-label="Services">
            <div>
              <div style="float: right">
                <md-button
                  class="md-icon-button md-primary md-simple new-app-button"
                  style="padding: 10px"
                  @click="showNewServiceDialog"
                >
                  <md-icon id="new-app-icon">note_add</md-icon>
                  New Service
                  <md-tooltip md-direction="top">Add new service</md-tooltip>
                </md-button>
                <loading-icon-button tooltip="Refresh" style="padding: 10px" @click="getServices">
                  refresh
                </loading-icon-button>
              </div>
              <!-- Service Editor -->
              <md-dialog :md-active.sync="progress_indicator_service.edit_service">
                <div class="dialogWrapper">
                  <md-dialog-title>{{
                    progress_indicator_service.dialog_title_service
                  }}</md-dialog-title>
                  <br />
                  <div class="md-layout">
                    <!-- Service Name -->
                    <validated-text-input
                      class="md-layout-item md-small-size-100 md-size-40"
                      label="Service Name"
                      v-model="new_service.name"
                      required
                    >
                    </validated-text-input>
                    <!-- Service Description -->
                    <div class="md-layout-item md-small-size-100 md-size-100">
                      <md-field>
                        <label>Description</label>
                        <md-textarea v-model="new_service.description" required></md-textarea>
                      </md-field>
                    </div>
                    <div>
                      <!-- Service Enable/Disable -->
                      <md-switch class="md-layout-item" v-model="new_service.enabled">
                        <small class="switch-custom-label">Service</small>
                      </md-switch>

                      <!-- Opt In Enable/Disable -->
                      <md-switch class="md-layout-item" v-model="new_service.opt_in">
                        <small class="switch-custom-label">Opt In</small>
                      </md-switch>
                    </div>
                  </div>
                  <md-dialog-actions>
                    <md-button class="md-primary md-simple" @click="onEditServiceCancel"
                      >Cancel</md-button
                    >
                    <md-button
                      v-if="this.progress_indicator_service.dialog_title_service === 'New Service'"
                      class="md-primary md-simple"
                      @click="createNewService"
                      :disabled="!new_service.name || !new_service.description"
                      >Save</md-button
                    >
                    <md-button
                      v-else
                      class="md-primary md-simple"
                      @click="updateService"
                      :disabled="!new_service.name || !new_service.description"
                      >Save</md-button
                    >
                  </md-dialog-actions>
                </div>
              </md-dialog>
              <ServicesList
                :items="services"
                @edit-service="editService"
                @delete-service="deleteService"
                @service-change="
                  (item) => {
                    new_service = item;
                    updateService();
                  }
                "
              ></ServicesList>
            </div>
          </md-tab>

          <!-- Opt In Services Start -->
          <md-tab id="tab-opt-in" md-label="Opt in Services">
            <div>
              <div style="float: right">
                <md-button
                  class="md-icon-button md-primary md-simple new-app-button"
                  style="padding: 10px; padding-right: 17px; width: 200px!important;"
                  @click="showNewServiceOptInDialog"
                >
                  <md-icon id="new-app-icon">note_add</md-icon>
                  New Opt-In Subscription
                  <md-tooltip md-direction="top">Add new opt in subscription</md-tooltip>
                </md-button>
                <loading-icon-button
                  style="padding: 10px"
                  tooltip="Refresh"
                  @click="getServiceSubscription"
                >
                  refresh
                </loading-icon-button>
              </div>
              <!-- Service Opt In Editor -->
              <md-dialog :md-active.sync="progress_indicator_service_opt_in.edit_service_opt_in">
                <div class="dialogWrapper">
                  <md-dialog-title>{{
                    progress_indicator_service_opt_in.dialog_title_service_opt_in
                  }}</md-dialog-title>
                  <br />
                  <br />
                  <div class="md-layout">
                  <div class="md-layout-item md-inline-checkboxes">
                    <md-checkbox v-model="typeOfUser" :value="'Broker'">Broker</md-checkbox>
                    <md-checkbox v-model="typeOfUser" :value="'Agent'">Agent</md-checkbox>
                  </div>
                </div>
                  <div v-if="new_opt_in_service.user" class="md-layout">
                    <!-- Opt In User Name -->
                    <validated-autocomplete-input
                      class="md-layout-item md-small-size-100 md-size-50"
                      :label="getDynamicLabel"
                      v-model="fullName"
                      :options="getUsers"
                      required
                      force
                      :disabled="
                        this.progress_indicator_service_opt_in.dialog_title_service_opt_in !==
                        'New Opt In Service'
                      "
                    />
                    <!-- Opt In Service Name -->
                    <validated-autocomplete-input
                      class="md-layout-item md-small-size-100 md-size-50"
                      label="Service"
                      v-model="new_opt_in_service.zink_service.name"
                      :options="getServicesByUser"
                      required
                      force
                      :disabled="
                        this.progress_indicator_service_opt_in.dialog_title_service_opt_in !==
                        'New Opt In Service'
                      "
                    />
                    <!-- Opt In Service Enable/Disable -->
                    <div class="md-layout-item md-small-size-100 md-size-60">
                      <md-switch v-model="new_opt_in_service.enabled">
                        <small class="switch-custom-label">Opt In Service</small>
                      </md-switch>
                    </div>
                  </div>
                  <md-dialog-actions>
                    <md-button class="md-primary md-simple" @click="onEditServiceOptInCancel"
                      >Cancel</md-button
                    >
                    <md-button
                      v-if="
                        this.progress_indicator_service_opt_in.dialog_title_service_opt_in ===
                        'New Opt In Service'
                      "
                      class="md-primary md-simple"
                      @click="createNewServiceOptIn"
                      :disabled="!new_opt_in_service.user || !new_opt_in_service.zink_service.name"
                      >Save</md-button
                    >
                    <md-button v-else class="md-primary md-simple" @click="updateServiceOptIn"
                      >Save</md-button
                    >
                  </md-dialog-actions>
                </div>
              </md-dialog>
              <data-table
                :headers="optInHeaders"
                v-model="service_subscription"
                :items-per-page="10"
                title="Opt In Services"
                filterable
              >
                <template v-slot:item.service_name="{ item }">
                  {{ item.zink_service.name }}
                </template>

                <template v-slot:item.enabled="{ item }">
                  <md-switch
                    class="md-layout-item"
                    v-model="item.enabled"
                    @change="
                      () => {
                        new_opt_in_service = item;
                        updateServiceOptIn();
                      }
                    "
                  ></md-switch>
                </template>

                <template v-slot:item.opt_in_action="{ item }">
                  <loading-icon-button
                    tooltip="Delete Opt In Service"
                    @click="
                      showActionDialog(
                        `Do you wish to delete ${item.zink_service.name} for ${item.user.name.first_name} ${item.user.name.last_name}?`,
                        () => deleteServiceOptIn(item)
                      )
                    "
                    :loading="
                      progress_indicator_service_opt_in_ids.remove_service_opt_in_id == item.id
                    "
                  >
                    clear
                  </loading-icon-button>
                </template>
              </data-table>
              <md-dialog-confirm
                :md-active.sync="action_dialog.show"
                :md-title="action_dialog.title"
                :md-content="action_dialog.content"
                :md-confirm-text="action_dialog.confirm_text"
                :md-cancel-text="action_dialog.cancel_text"
                @md-confirm="action_dialog.action"
              />
            </div>
          </md-tab>
          <md-tab id="tab-opt-in-auction" md-label="Opt In Auctions">
            <AuctionOptInList />
          </md-tab>
        </md-tabs>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import ValidatedInputs from "@/components/ValidatedInput";
import LoadingIconButton from "@/components/LoadingIconButton";
import DataTable from "@/components/DataTable";
import ServicesList from "../components/ServicesList";
import filters from "@/components/utils/filters";
import { newService, newOptInService } from "../schema";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import AuctionOptInList from "./AdministrateOptInAuctionList.vue";

export default {
  components: {
    ...ValidatedInputs,
    DataTable,
    LoadingIconButton,
    ServicesList,
    ConfirmDialog,
    AuctionOptInList,
  },
  data() {
    return {
      action_dialog: {
        show: false,
        content: "",
        title: "",
        confirm_text: "Confirm",
        cancel_text: "Cancel",
        action: () => {},
      },
      fullname: "",
      typeOfUser: "Broker",
      services: [],
      service_subscription: [],
      new_service: newService(),
      new_opt_in_service: newOptInService(),
      progress_indicator_service_opt_in_ids: {
        edit_service_opt_in_id: false,
        remove_service_opt_in_id: false,
      },
      progress_indicator_service: {
        edit_service: false,
        edit_service_id: null,
        dialog_title_service: "Edit Service",
      },
      progress_indicator_service_opt_in: {
        edit_service_opt_in: false,
        edit_service_opt_in_id: null,
        dialog_title_service_opt_in: "Edit Opt In Service",
      },
      optInHeaders: [
        {
          text: "User Name",
          value: "user_name",
          valueFunction(item) {
            return filters.name(item.user.name);
          },
          sort: true,
          search: true,
        },
        {
          text: "Service Name",
          value: "service_name",
          sort: true,
          search: true,
        },
        {
          text: "Enabled/Disabled",
          value: "enabled",
          sort: true,
          search: true,
        },
        {
          text: "Created On",
          value: "created_at",
          filter: filters.dateonly,
          sort: true,
          search: true,
        },
        {
          text: "Updated On",
          value: "updated_at",
          filter: filters.dateonly,
          sort: true,
          search: true,
        },
        {
          text: "Action",
          value: "opt_in_action",
          sort: false,
        },
      ],
    };
  },
  watch: {
    typeOfUser() {
      // Resets each time checkbox changes
      this.new_opt_in_service = newOptInService();
      this.fullName = "";
    }
  },
  computed: {
    getDynamicLabel() {
      if (this.typeOfUser === 'Agent') {
        return 'Agent';
      }  else {
        return 'Broker'; // Return default user label
      }
    },
    getServicesByUser() {
      if (this.typeOfUser === 'Agent') {
        // Only include "Agent Visibility" service
        return this.services.filter((i) => i.name === 'Agent Visibility').map((i) => i.name);
      }  else {
        // Exclude "Agent Visibility" service
        return this.services.filter((i) => i.name !== 'Agent Visibility').map((i) => i.name);
      }
    },
    getUsers() {
      if (this.typeOfUser === 'Agent') {
        return this.getAgents.map((i) => i.id + " - " + i.full_name);
      }  else {
        return this.getBrokers.map((i) => i.name) // Return default users
      }
    },
    getBrokers() {
      if (this.$store.state.administration_brokers) {
        return [...this.$store.state.administration_brokers];
      }
      return [];
    },
    getAgents() {
      if (this.$store.state.all_types_agents) {
        return [...this.$store.state.all_types_agents];
      }
      return [];
    },
    fullName: {
      get() {
        return (
          this.new_opt_in_service.user.name.first_name +
          " " +
          this.new_opt_in_service.user.name.last_name
        );
      },
      set(newValue) {
        if (newValue) {
          this.fullname = newValue.split(" ");
          if (this.typeOfUser === 'Broker') {
            this.new_opt_in_service.user.name.first_name = this.fullname[0];
            this.new_opt_in_service.user.name.last_name = this.fullname[1];
          } else {
            // Starts after id and hyphen for agents
            this.new_opt_in_service.user.name.first_name = this.fullname[2];
            this.new_opt_in_service.user.name.last_name = this.fullname[3];
          }
        }
      },
    },
  },
  methods: {
    getBrokerId() {
      this.getBrokers.find((i) => {
        if (i.name === this.fullname[0] + " " + this.fullname[1]) {
          this.new_opt_in_service.user.id = i.id;
          return true;
        }
      });
    },
    getAgentId() {
      this.getAgents.find((i) => {
        if (i.full_name === this.fullname[2] + " " + this.fullname[3]) {
          this.new_opt_in_service.user.id = i.id;
          return true;
        }
      });
    },
    getServiceId() {
      this.services.find((i) => {
        if (i.name === this.new_opt_in_service.zink_service.name) {
          this.new_opt_in_service.zink_service.id = i.id;
          return true;
        }
      });
    },
    //service methods
    async getServices() {
      await axios
        .get(`/api/v1/administration/zink_services`)
        .then((res) => {
          this.services = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.showConfirmDialog("Error", "Failed to get the services");
        });
    },
    async editService(service) {
      this.new_service = service;
      this.progress_indicator_service.dialog_title_service = `Edit ${service.name}`;
      this.progress_indicator_service.edit_service = true;
    },
    onEditServiceCancel() {
      this.getServices();
      this.progress_indicator_service.edit_service = false;
    },
    showNewServiceDialog() {
      this.new_service = newService();
      this.progress_indicator_service.dialog_title_service = "New Service";
      this.progress_indicator_service.edit_service = true;
    },
    async createNewService() {
      try {
        await axios.post(`/api/v1/administration/zink_services`, this.new_service);
        await this.getServices();
      } catch (error) {
        console.log(error);
        this.showConfirmDialog("Error", "Failed to create new service");
      }
      this.progress_indicator_service.edit_service = false;
    },
    async updateService() {
      try {
        await axios.patch(
          `/api/v1/administration/zink_services/${this.new_service.id}`,
          this.new_service
        );
        await this.getServices();
      } catch (error) {
        console.log(error);
        this.showConfirmDialog("Error", "Failed to update the service");
      }
      this.progress_indicator_service.edit_service = false;
    },
    deleteService(service) {
      this.showActionDialog(
        `Do you wish to delete ${service.name}?`,
        async () => {
          try {
            await axios.delete(`/api/v1/administration/zink_services/${service.id}`);
            await this.getServices();
            this.showConfirmDialog("Deleted successfully",`The ${service.name} service has been deleted.`);
          } catch (error) {
            console.log(error);
            this.showConfirmDialog("Error", "Failed to delete the service");
          }
        }
      );
    },
    //opt in service methods
    async getServiceSubscription() {
      await axios
        .get(`/api/v1/administration/zink_service_subscriptions`)
        .then((res) => {
          this.service_subscription = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.showConfirmDialog("Error", "Failed to get the opt in services");
        });
    },
    onEditServiceOptInCancel() {
      this.getServiceSubscription();
      this.progress_indicator_service_opt_in.edit_service_opt_in = false;
    },
    showNewServiceOptInDialog() {
      this.new_opt_in_service = newOptInService();
      this.progress_indicator_service_opt_in.dialog_title_service_opt_in = "New Opt In Service";
      this.progress_indicator_service_opt_in.edit_service_opt_in = true;
    },
    async createNewServiceOptIn() {
      if(this.typeOfUser === 'Agent') {
        this.getAgentId();
      } else {
        this.getBrokerId();
      }
      this.getServiceId();
      try {
        await axios.post(`/api/v1/administration/zink_service_subscriptions`, {
          user_id: this.new_opt_in_service.user.id,
          service_id: this.new_opt_in_service.zink_service.id,
          enabled: this.new_opt_in_service.enabled,
        });
        await this.getServiceSubscription();
        let message = !this.new_opt_in_service.enabled ? " Do not forget to turn service ON!":" Service is active!"
        this.showConfirmDialog("Success",
          `User ${this.fullName} has been subscribed to service ${this.new_opt_in_service.zink_service.name}.` + message);
      } catch (error) {
        console.log(error);
        this.showConfirmDialog("Error", "Failed to create new opt in service");
      }
      this.progress_indicator_service_opt_in.edit_service_opt_in = false;
    },
    async updateServiceOptIn() {
      try {
        await axios.patch(
          `/api/v1/administration/zink_service_subscriptions/${this.new_opt_in_service.id}`,
          {
            user_id: this.new_opt_in_service.user.id,
            service_id: this.new_opt_in_service.zink_service.id,
            enabled: this.new_opt_in_service.enabled,
          }
        );
        await this.getServiceSubscription();
        let state = this.new_opt_in_service.enabled ? 'activated!' : 'deactivated!'
        this.showConfirmDialog("Success", `The ${this.new_opt_in_service.zink_service.name} service subsription is ` + state);
      } catch (error) {
        console.log(error);
        this.showConfirmDialog("Error", "Failed to update opt in service");
      }
      this.progress_indicator_service_opt_in.edit_service_opt_in = false;
    },
    async deleteServiceOptIn(opt_in_service) {
      try {
        await axios.delete(
          `/api/v1/administration/zink_service_subscriptions/${opt_in_service.id}`
        );
        await this.getServiceSubscription();
        this.showConfirmDialog("Deleted successfully",`The ${opt_in_service.zink_service.name} service subscription for ${opt_in_service.user.name.first_name} ${opt_in_service.user.name.last_name} has been deleted.`);
      } catch (error) {
        console.log(error);
        this.showConfirmDialog("Error", "Failed to delete opt in service");
      }
    },
    showConfirmDialog(title, message) {
      this.$modal.show(ConfirmDialog, {
        title: title,
        message: message,
        confirmText: "Ok",
      });
    },
    showActionDialog(content, action, buttonOptions = {}, show = true) {
      this.action_dialog.content = content;
      this.action_dialog.confirm_text = buttonOptions.confirm ?? "Confirm";
      this.action_dialog.cancel_text = buttonOptions.cancel ?? "Cancel";
      this.action_dialog.action = action;
      this.action_dialog.show = show;
    },
    ...filters,
  },
  async created() {
    this.getServices();
    this.getServiceSubscription();
    this.$store.dispatch("get_broker_query", false);
    this.$store.dispatch("get_all_types_agents_query", false);
  },
  filters: {
    ...filters,
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";
.dialogWrapper {
  padding-top: 15px;
}
.switch-custom-label {
  color: rgba(0, 0, 0, 0.54) !important;
}
</style>
